import { compact } from 'lodash';
export default function generateLanguages(rawCharacter) {
    return compact([
        'Galactic Basic',
        rawCharacter.species.language,
        ...(rawCharacter.background.languages || [])
    ]);
}
